/**
 * View transitions API setup
 */
/*! Warning: this can't load in the footer or animations won't apply quickly enough to occur */

/**
 * Import dependencies
 */
import onReady from "../../util/onReady"

/**
 * Attach view transitions to anything with attribute data-vt-id
 */

// add wait then remove view transition names
const pair = async (el, prom) => {
	if (el?.style) {
		el.style.viewTransitionName = el.dataset.vtId
		await prom
		el.style.viewTransitionName = ""
	}
}

// on exit of old page add view transition names
window.addEventListener("pageswap", async (e) => {
	// bail if this isn't a view transition or we're doing a full page transition
	if (!e.viewTransition || localStorage.getItem("viewTransitionName")) return
	// mach pairs of unique animation elements
	document.querySelectorAll("[data-vt-id]")?.forEach((outEl) => {
		pair(outEl, e.viewTransition.finished)
	})
})

// on enter of new page add view transition names
window.addEventListener("pagereveal", async (e) => {
	// bail if this isn't a view transition or we're doing a full page transition
	if (!e.viewTransition || localStorage.getItem("viewTransitionName")) return
	// mach pairs of unique animation elements
	document.querySelectorAll("[data-vt-id]")?.forEach((outEl) => {
		pair(outEl, e.viewTransition.ready)
	})
})

/**
 * Re-enable smooth scrolling and ani transitions after page loads
 */
onReady(() => {
	document.querySelector("html").classList.remove("disable-animated-scroll")
	setTimeout(() => {
		document.querySelector("html").classList.remove("disable-vt-ani")
	}, 600)
})

/**
 * Handle full-page transitions for appropriate page paths
 */
const fullPages = [
	'/contact/'
]

// on exit of old page add view transition names
window.addEventListener("pageswap", async (e) => {
	// bail if this isn't a view transition
	if (!e.viewTransition) return
	if (fullPages.includes(new URL(e.activation.entry.url).pathname)) {
		localStorage.setItem("viewTransitionName", "full-page");
			document.querySelector("html").style.viewTransitionName =
				"full-page"
	}
})

/**
 * Use full-page transitions on main navigation clicks
 */
// if users click an appropriate link then set outgoing full page transition ID
onReady(() => {
	document.querySelectorAll('.menu-main__links a')?.forEach((el) => {
		el.addEventListener("click", (e) => {
			localStorage.setItem("viewTransitionName", "full-page");
			document.querySelector("html").style.viewTransitionName =
				"full-page"
		})
	})
})

// while loading a new page
window.addEventListener("pagereveal", async (e) => {
	// bail if this isn't a view transition
	if (!e.viewTransition) return
	// if we're to transition then do so then clear out the transition name
	if (localStorage.getItem("viewTransitionName")) {
		document.querySelector("html").style.viewTransitionName = localStorage.getItem("viewTransitionName")
		localStorage.setItem("viewTransitionName", "");
	}
	// clear full page transition when done (so the logic above can add it back only if appropriate)
	await e.viewTransition.ready;
	document.querySelector("html").style.viewTransitionName = ""
})
